export type ProcessStep = {
  title: string;
  description: string;
};

export const processSteps: ProcessStep[] = [
  {
    title: "Discover",
    description: "Workshops to align on users, goals, and what success looks like.",
  },
  {
    title: "Design",
    description: "Prototypes and visual systems your team can validate quickly.",
  },
  {
    title: "Deliver",
    description: "Senior engineering ships dependable releases and iterates fast.",
  },
];
